import React, { forwardRef } from 'react';

type OwnProps = React.SVGProps<SVGSVGElement>;

const ShareIconAlt = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="black"
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.2929 8.70707C15.6834 9.0976 16.3166 9.0976 16.7071 8.70707C17.0976 8.31655 17.0976 7.68338 16.7071 7.29286L12.7071 3.29286C12.3166 2.90234 11.6834 2.90234 11.2929 3.29286L7.29289 7.29286C6.90237 7.68338 6.90237 8.31655 7.29289 8.70707C7.68342 9.0976 8.31658 9.0976 8.70711 8.70707L11 6.41418V14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14L13 6.41418L15.2929 8.70707ZM5 13C5 12.4477 4.55228 12 4 12C3.44772 12 3 12.4477 3 13V18.75C3 19.9926 4.00736 21 5.25 21H18.75C19.9926 21 21 19.9926 21 18.75V13C21 12.4477 20.5523 12 20 12C19.4477 12 19 12.4477 19 13V18.75C19 18.888 18.8881 19 18.75 19H5.25C5.11193 19 5 18.888 5 18.75V13Z"
      fill="#183558"
    />
  </svg>
));

export default ShareIconAlt;
